// DS: MO 4.1.5
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import FragmentsIcon from '@wix/da-ds/pkg/Icons/24x24/Fragments';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import { Measured, MeasuredCookieType } from '../../../../Measured';
import { first } from '../../../../utils/fp';
import Dumbo from '../../../../DeviationViews/Dumbo';
import UserLink from '../../../../User/Link/UserLink';
import CreateButton from './CreateButton';
import s from './DreamupPromo.scss';
const DreamupPromo = ({ block: { deviations = [] } })=>{
    const { t } = useTranslation();
    const deviation = first(deviations);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['root'],
        href: Url.dreamupLink(),
        biData: BiData({
            evid: 923,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue
        })
    }, /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement("div", {
        className: s['top-section']
    }, deviation && /*#__PURE__*/ React.createElement(Measured, {
        cookieType: MeasuredCookieType.DREAMUP_SIDEBAR_PROMO,
        cookieDim: "width",
        listenOnWindow: true
    }, ({ container, onRef })=>/*#__PURE__*/ React.createElement("div", {
            className: s['deviation-wrapper'],
            ref: onRef
        }, /*#__PURE__*/ React.createElement(Dumbo, {
            deviation: deviation,
            width: container === null || container === void 0 ? void 0 : container.width,
            height: 224,
            "aria-hidden": "true",
            useCoverMode: true
        }), deviation.author && /*#__PURE__*/ React.createElement("p", {
            className: s['attribution']
        }, t('sidebar.dreamupPromo.attribution', {
            postProcess: 'reactPostprocessor',
            userLink: /*#__PURE__*/ React.createElement(UserLink, {
                className: c(s['attribution-user-link']),
                user: deviation.author,
                showSymbol: false,
                stopPropagation: true
            })
        })))), /*#__PURE__*/ React.createElement(Heading, {
        className: s['heading']
    }, t('sidebar.dreamupPromo.heading')), /*#__PURE__*/ React.createElement("p", {
        className: s['description']
    }, t('sidebar.dreamupPromo.description'))), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-section']
    }, /*#__PURE__*/ React.createElement(DaDreamupLogoAndText, {
        className: s['logo'],
        "aria-label": t('sidebar.dreamupPromo.logo.a11y.label')
    }), /*#__PURE__*/ React.createElement(CreateButton, {
        icon: FragmentsIcon,
        // This should be removed from the tab order since it isn't a link or a button, we're just using the styles at
        // this point.
        "aria-hidden": "true",
        tabIndex: -1
    }, t('sidebar.dreamupPromo.button.label')))));
};
DreamupPromo.displayName = 'DreamupPromo';
export default DreamupPromo;
